import {FC, useState} from "react";
import {RichTextParser} from "../../../utils/RichTextParser";

interface IProps {
  title: string;
  text: string | any[] | any;
}

export const BlockTextCrgci: FC<IProps> = ({title, text}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div
      style={{
        color: "white",
        width: "100%",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        borderRadius: "12px",
        padding: "3px 16px",
        backgroundColor: "#22272B",
        gap: 12,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            fontSize: 16,
            textTransform: "uppercase",
            color: "#56B3FF",
            fontWeight: 600,
          }}
        >
          {title}
        </div>
        <div
          style={{
            color: "#FAFAFA",
            fontSize: 30,
            fontWeight: 100,
            cursor: "pointer",
            transition: "transform 0.3s ease",
          }}
          onClick={toggleExpanded}
        >
          {isExpanded ? "−" : "+"}
        </div>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateRows: isExpanded ? "1fr" : "0fr",
          opacity: isExpanded ? 1 : 0,
          transition: "grid-template-rows 0.3s ease-in-out, opacity 0.3s ease-in-out",
        }}
      >
        <div style={{overflow: "hidden", paddingBottom: isExpanded ? "12px" : "0"}}>
          <RichTextParser content={text} />
        </div>
      </div>
    </div>
  );
};
